import script from "./SideEffectLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./SideEffectLoading.vue?vue&type=script&setup=true&lang=js"

import "./SideEffectLoading.vue?vue&type=style&index=0&id=09277166&lang=css"

const __exports__ = script;

export default __exports__